import React from 'react';
import { connect } from 'react-redux';
import { validateFloat } from "../../common/validation/Validators"
import Select from 'react-select'

const StatutoryPaymentRow = ({ index, currency, filteredList, selectedStatutoryPayments, statutoryPayments, disabled, updateStatutoryPayment, setStatutoryPayment }) => {
    const currentIndex = selectedStatutoryPayments?.[index]
    // console.debug(selectedStatutoryPayments, currentIndex)
    return (
        <div className="col-xs-12">
            <div className="col-xs-4 pl-0">
                <div className='form-material form-container'>
                    <label >Type</label>
                    <Select
                        value={statutoryPayments?.find(item => item.value === currentIndex?.type)}
                        isDisabled={disabled}
                        onChange={(selected) => {
                            updateStatutoryPayment({ index, type: selected?.value || null })
                        }}
                        options={filteredList}
                        auto
                    />
                </div>
            </div>
            <div className="col-xs-3 pl-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Contribution</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}
                        className="form-control form-input"
                        value={currentIndex?.contribution}
                        onChange={(e) => {
                            updateStatutoryPayment({ index, contribution: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-5">
                <button
                    disabled={disabled}
                    className='btn pull-right'
                    type='button'
                    style={{ marginTop: '1.25rem' }}
                    onClick={() => {
                        if (disabled) return
                        selectedStatutoryPayments.splice(index, 1)
                        setStatutoryPayment(selectedStatutoryPayments)
                    }}
                >
                    <div style={{ float: "left" }}>Remove</div>
                </button>
            </div>
        </div>
    )

}


const mapStateToProps = (state, ownProps) => {

    return {
        currency: state.company?.settings?.currency,
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(StatutoryPaymentRow);

